import React, {Component} from 'react';

import formatters from "../../../../../utils/formatters";

export default class TripProgrammingForm extends Component {

    render() {
        let trip = this.props.trip;
        if(!trip)return <div />;

        let estimated_load_date = trip.estimated_load_date;
        if(trip.estimated_load_date){
            estimated_load_date = formatters.dateFormat(trip.estimated_load_date);
        }

        let form = (
            <div className={"row"}>
                <div className={"col s6 no-padding"}>
                    <div style={{height: 37, backgroundColor: '#d9d9d9', padding: 10}}>
                        <h4 className={'table-subtitle'}>Información Viaje</h4>
                    </div>
                    <div className={"row margin-top-10"}>
                        <div className={"col s6 input-field"}>
                            <label className="active">Proveedor</label>
                            <p className={"field-p truncate"}>{trip.provider.business_name}</p>
                        </div>
                        <div className={"col s6 input-field"}>
                            <label className="active">Producto</label>
                            <p className={"field-p"}>{trip.product.code}</p>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col s6 input-field input-grey"}>
                            <label className="active">Tipo de viaje</label>
                            <p className={"field-p"}>Viaje {trip.incoterm.name}</p>
                        </div>
                        <div className={"col s6 input-field"}>
                            <label className="active">Destino</label>
                            <p className={"field-p"}>{trip.terminal.name}</p>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col s6 input-field input-grey"}>
                            <label className="active">Orden ST</label>
                            <p className={"field-p"}>{trip.st_number}</p>
                        </div>
                        <div className={"col s6 input-field input-grey"}>
                            <label className="active">Cia ST</label>
                            <p className={"field-p"}>{trip.st_company}</p>
                        </div>
                    </div>
                    <div className={"row no-margin"}>
                        <div className={"col s6 input-field input-grey"}>
                            <label className="active">Número de Línea</label>
                            <p className={"field-p"}>{trip.line_number}</p>
                        </div>
                        <div className={"col s6 input-field input-grey"}>
                            <label className="active">Cantidad de Litros a 15º</label>
                            <p className={"field-p"}>{formatters.intFormat(trip.order_volume)}</p>
                        </div>
                    </div>
                </div>
                <div className={"col s6 no-padding"}>
                    <div style={{height: 37, backgroundColor: '#d9d9d9', padding: 10}}>
                        <h4 className={'table-subtitle'}>Información Transporte</h4>
                    </div>
                    <div style={{borderLeft: '1px solid #404040', paddingLeft: 20}}>
                        <div className={"row margin-top-10"}>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Empresa Transportista</label>
                                <p className={"field-p"}>{trip.carrier}</p>
                            </div>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">C.U.I.T</label>
                                <p className={"field-p"}>{formatters.cuit(trip.carrier_doc)}</p>
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Chofer - Nombre y Apellido</label>
                                <p className={"field-p"}>{trip.driver_name}</p>
                            </div>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Licencia de Conducir</label>
                                <p className={"field-p"}>{trip.driver_doc}</p>
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={"col s6 input-field "}>
                                <label className="active">Fecha estimada de Carga</label>
                                <p className={"field-p"}>{estimated_load_date}</p>
                            </div>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Transporte Unidad</label>
                                <p className={"field-p"}>{trip.truck_id}</p>
                            </div>
                        </div>
                        <div className={"row no-margin"}>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Patente Chasis</label>
                                <p className={"field-p"}>{trip.truck_plate}</p>
                            </div>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Patente Acoplado</label>
                                <p className={"field-p"}>{trip.trailer_plate}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        if(this.props.boxed){
            return (
                <div className={"trip-section"}>
                    <div className={'trip-section-title'}>Viaje Ingresado</div>
                    {form}
                </div>
            );
        }

        return form;
    }
}


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/Trip/Done/TripProgrammingForm.js